import * as CryptoJS from 'crypto-js';
const key = CryptoJS.enc.Utf8.parse("contractorPortal"); // 256-bit key (32 characters)
const salt = { "words": [130332099, 3412898925, 4080727054, 1733911705], "sigBytes": 16 };
export class UtilitySupport  {
  
    static genRandonString(length: number) {
        let chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()';
        let charLength = length;
        let result = '';
        for (let i = 0; i < charLength; i++) {
          result += chars.charAt(Math.floor(Math.random() * charLength));
        }
        return result;
      }
      static encryptMessage(message:any, key:any, salt:any) {
        const keySize = 512; // 256 bits
        const iterations = 1000;
    
        const encrypted = CryptoJS.AES.encrypt(message, key, {
          keySize: keySize / 16,
          iv: salt,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
          iterations: iterations
        });
    
        return encrypted.toString();
      }
      // static encode(str: string) {
      //   return this.genRandonString(128) + this.genRandonString(128) + "-" + btoa(str) + "-" + this.genRandonString(128) + this.genRandonString(128);
      // }
      static encode(str: string) {   
        const ciphertext = this.encryptMessage(str, key, salt);
        return btoa(ciphertext);
      }
      static encryptSaltMessage(message:any, key:any) {
        const keySize = 512; // 256 bits
        const iterations = 1000;
    
        const encrypted = CryptoJS.AES.encrypt(message, key, {
          keySize: keySize / 16,
          //iv: salt,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
          iterations: iterations
        });
    
        return encrypted.toString();
      }
      static encodeSalt(str: string,key:string) {   
        const ciphertext = this.encryptSaltMessage(str, key);
        
        //return btoa(ciphertext);
        return btoa(ciphertext);
      }

}